import type { FilterOptions, Order } from '~/types'

export interface OrderHistoryResponse {
  totalOrders: number
  orders: Order[]
  filterOptions: FilterOptions
}

function requestUrl(request: unknown): string {
  if (typeof request === 'string') return request
  if (request && typeof request === 'object' && 'url' in request)
    return String((request as { url: unknown }).url ?? '')
  return String(request ?? '')
}

/** True when this ofetch request still belongs to the currently selected customer. */
export function isOrderHistoryRequestForCustomer(request: unknown, customerHandle: string | undefined): boolean {
  if (!customerHandle) return false
  return requestUrl(request).includes(`/customers/${customerHandle}/`)
}

/** Append incoming orders, skipping handles already in `existing`. */
export function mergeOrderHistoryList(existing: Order[], incoming: Order[] | undefined): Order[] {
  const seen = new Set(existing.map(o => o.handle))
  const next = [...existing]
  for (const order of incoming ?? []) {
    if (seen.has(order.handle)) continue
    seen.add(order.handle)
    next.push(order)
  }
  return next
}
